import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { clientManagementFeature, ClientManagementEffects } from './store';

export function provideClientManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(clientManagementFeature),
    provideEffects(ClientManagementEffects),
  ]);
}
